import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: '#292739',
  boxShadow: 24,
  p: 4,
  borderRadius: '25px',
  outline: 'none',
};

const imgStyle = {
  width: '100%',
  objectFit: 'scale-down',
} as React.CSSProperties;

interface IRewardsModalProps {
  children: JSX.Element | string;
}

const RewardsModal = ({ children }: IRewardsModalProps) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const rewardsImg = require('assets/rewards.png');
  return (
    <div>
      <span onClick={handleOpen}>{children}</span>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <img style={imgStyle} src={rewardsImg} alt="" />
          <Typography
            sx={{ color: 'white' }}
            id="modal-modal-title"
            variant="h6"
            component="h2"
          >
            Rewards Coming Soon
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Rewards are split into 2 unique features. Creators can earn based on
            how their followers enjoy your content. Thanks to our reinvention of
            how advertisement works, ads reward you the viewer for watching. Our
            system them automatically detects whos content you've enjoyed the
            most at the end of the month, and then pays out to those top 3
            creators. In addition, we will host a creator fund to unique
            creators that are recognizable.
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default RewardsModal;
